import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useGetMeQuery } from "../services/user";
import ROUTES from ".";
import { config } from "../config";
import { useLazyGetSingleOrganizationQuery } from "../services/organization";

const PrivateRoute = ({ children }) => {
	const accessToken = localStorage.getItem(config.accessTokenName) || "";
	if (!accessToken) return <Navigate to={ROUTES.PATHS.LOGIN} />;

	const { data, isError } = useGetMeQuery(accessToken);
	const [getOrgById] = useLazyGetSingleOrganizationQuery();

	useEffect(() => {
		if (data && data.success) {
			if (!data.user.isActive) {
				return <Navigate to={ROUTES.PATHS.INACTIVE_ACCOUNT} />;
			}
			getOrgById(data.user.organization, false);
		}
	}, [data]);

	if (isError) {
		localStorage.removeItem(config.accessTokenName);
		return <Navigate to={ROUTES.PATHS.LOGIN} />;
	}

	return children;
};

export default PrivateRoute;
